// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"73":"7003e82c","208":"74a3cbd1","315":"00cadbfd","409":"5139796b","511":"8b36f546","741":"32857fe2","765":"b39ca69b","774":"9da6dd68","787":"0bde0c9b","991":"d4504dc6"}[chunkId] + ".chunk.js";
};